import { faSparkles } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AiIndicator = ({ text }: { text: string }) => {
  return (
    <div className="vai-flex vai-self-start vai-items-center vai-gap-2 vai-bg-gradient-to-r vai-from-indigo-600 vai-to-violet-600 vai-py-1 vai-px-2 vai-rounded-full vai-mb-1">
      <FontAwesomeIcon color="white" icon={faSparkles} />
      <p className="vai-text-[12px] vai-font-semibold vai-font-inter vai-text-white">
        {text}
      </p>
    </div>
  );
};

export default AiIndicator;
